import React from "react";
import Image from "next/image";
import { useTranslation } from "next-i18next";

import { CategoryEntity, SubCategoryEntity } from "gql-types";
import { useGlobalState } from "context/GlobalStateContext";
import selectGroupIcon from "/public/images/selectGroupIcon.svg";
import SearchInput from "components/ui_components/SearchInput";

import { categoryTranslateKey, subCategoryTranslateKey } from "../../helpers/constants/translate";
import AffariyetSelect from "./affariyetSelect";

type FilterOptionsPropsType = {
  setSearchQuery: (value: string) => void;
  searchQuery: string;
  setAffariyetOfToday: (value: boolean) => void;
  setSelectedCategory: (value: string) => void;
  setSelectedSubCategory: (value: string) => void;
  categories: CategoryEntity[];
  subCategories: SubCategoryEntity[];
};

function FilterOptions({
  setSearchQuery,
  searchQuery,
  setAffariyetOfToday,
  setSelectedCategory,
  setSelectedSubCategory,
  categories = [],
  subCategories = [],
}: FilterOptionsPropsType) {
  const { direction } = useGlobalState();
  const { t: translate } = useTranslation("offers");
  const { t: cat } = useTranslation("categories");

  //filter options
  function handleSelectCategory(event: React.ChangeEvent<HTMLSelectElement>) {
    setSelectedCategory(event.target.value);
  }

  function handleSelectSubCategory(event: React.ChangeEvent<HTMLSelectElement>) {
    setSelectedSubCategory(event.target.value);
  }

  function handleFilterAffariyetOfToday(event: React.ChangeEvent<HTMLInputElement>) {
    setAffariyetOfToday(event.target.checked);
  }

  return (
    <div className="flex flex-col lg:flex-row items-center  gap-3 w-full md:max-w-[500px] lg:max-w-full  ">
      <div className="w-full lg:w-2/3 h-full ">
        <SearchInput
          handleSearch={setSearchQuery}
          searchQuery={searchQuery}
          placeHolder={translate("search")}
        />
      </div>
      <AffariyetSelect
        name="categories"
        id="categories"
        handleChange={handleSelectCategory}
        defaultOption={{
          key: "categories",
          value: translate("categories"),
          text: translate("categories"),
        }}
        options={categories}
        translate={categoryTranslateKey}
      />
      <AffariyetSelect
        name="sub-categories"
        id="sub-categories"
        handleChange={handleSelectSubCategory}
        defaultOption={{
          key: "sub-categories",
          value: translate("sub-categories"),
          text: translate("sub-categories"),
        }}
        options={subCategories}
        translate={subCategoryTranslateKey}
      />
      <div className="w-full lg:w-2/6  flex flex-row gap-2 lg:gap-3 items-center   border-4 border-backgroundGrey rounded-lg p-3">
        <input
          type="checkbox"
          name="affariyet-of-today"
          id="affariyet-of-today"
          onChange={handleFilterAffariyetOfToday}
          className=" cursor-pointer transform scale-100 lg:scale-125 "
        />
        <label
          htmlFor="affariyet-of-today"
          className="text-sm  lg:text-base font-semibold leading-4 text-[#353535E5] cursor-pointer my-auto "
        >
          {translate("affariyetOfToday")}
        </label>
      </div>
    </div>
  );
}

export default FilterOptions;
